<template>
  <div class="fy-head">
    <router-link to="/"><img :src="logo" class="fy-head__logo"></router-link>
    <div class="fy-head__menu">
        <div class="fy-head__menu__item" v-for="item in menuList" :key="item.name">
          <router-link :to="item.url"><span>{{item.nameZh}} | </span>{{item.name}}</router-link>
        </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import logo from '@/assets/logo.png'
export default Vue.extend({
  name:'top-head',
  data () {
    return {
      menuList:[
        {
          name:'简介',
          nameZh: 'PROFILF',
          url:'/profile',
        },
        {
          name:'项目',
          nameZh: 'PROJECTS',
          url:'/design',
        },
        {
          name:'招聘',
          nameZh: 'JOIN',
          url:'/join_us',
        },
        {
          name:'联系',
          nameZh: 'CONTACT',
          url:'/contact_us',
        }
      ],
      logo,
    }
  },
  created(){
    this.getHomeConfig();
  },
  methods:{
     getHomeConfig(){
      this.$https.get("/api/homeConfig/getConfigByType",{params:{
        type:0
      }}).then((res) => {
        const img =res.data;     
        img?.id && (this.logo=img.imgPath)
      });
    }
  }
})
</script>